import React from 'react'
import './style.css'
const Marquee = () => {
  return (
    <div className='Lets_Talk_Button MyMarquee' style={{ fontSize : 'smaller' , fontWeight:'100', width:'40%', margin:'auto',backgroundColor:'rgb(19,19,19)',marginBottom:'10px'}}>
        <marquee > LATEST WORK AND FEATURED * LATEST WORK AND FEATURED * LATEST WORK AND FEATURED * LATEST WORK AND FEATURED * LATEST WORK AND FEATURED * LATEST WORK AND FEATURED *</marquee>
      </div>
  )
}

export default Marquee
